export default {
    confirmed: "您的账户无法确认",
    account: "请稍等，我们确认您的帐户",
    invalid: "链接中的代码无效。",
    settings: "回到设置",
    zhifou_account: "知否账户",
};
